export const TOP_SCROLL_THRESHOLD = 50
export const DRAG_AUTO_SCROLL_PX_AMOUNT = 5

export const PREVIOUS_URL_PATHNAME_KEY = 'previousUrlPathname'
export const PREVIOUS_URL_SEARCH_KEY = 'previousUrlSearch'

export const CHAT_MODAL_OPEN_KEY = 'chatModalOpen'
export const CHAT_ID_TO_OPEN_KEY = 'chatIdToOpen'

export const PONE_PLUS_WEBSITE_URL =
  'https://informaconnect.com/partneringone/plus?utm_source=referral&utm_medium=partneringone&utm_campaign=hub&utm_term=link&utm_content=IAMEA01L&tracker_id=IAMEA01L'

export const DEFAULT_DEV_MODE_TOKEN_VALUE = 'set-your-token-here'
